import React from "react";

interface ClientMapStatusPillProps {
    statusName: string;
}

export const ClientMapStatusPill: React.FC<ClientMapStatusPillProps> = props => {
    const { statusName } = props;
    return (
        <span className="inline-block rounded-full bg-gray-100 px-3 py-1 text-sm text-gray-800">
            {statusName}
        </span>
    );
};
